let TEST_URL = "http://localhost",
// let TEST_URL = "http://192.168.1.108",
  FORMAL_URL = "https://www.aschina.org.cn",
  isTEST = false, //是否是测试环境
  USER,
  REGISTER,
  MEETING,
  MEMBER;

if (isTEST) {
  USER = TEST_URL + ":7900"; //用户论证
  REGISTER = TEST_URL + ":7901"; //注册中心
  MEETING = TEST_URL + ":7905"; //会议服务
  MEMBER = TEST_URL + ":7906"; //会员服务
} else {
  USER = FORMAL_URL + "/uaa"; //用户论证
  REGISTER = FORMAL_URL + ":7901"; //注册中心
  MEETING = FORMAL_URL + "/meeting"; //会议服务
  MEMBER = FORMAL_URL + "/member"; //会员服务
}

export {
  USER,
  REGISTER,
  MEETING,
  MEMBER
};